import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mapToHttpParams } from '@bcl/common-ui';
import { Observable } from 'rxjs';
import { environment } from 'src/environments';
import { AddMonitorDialogResponse } from './components/add-monitor-dialog/add-monitor-dialog.model';
import { MonitorsPositionChanged } from './area-map.component';
import { ReplaceMonitorDialogResponse } from '../area-monitor/components/replace-monitor-dialog/replace-monitor-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class AreaMapApiService {
  constructor(private http: HttpClient) {}

  public getPartsForArea(
    areaId: number,
    visitId: number
  ): Observable<AreaContractPart[]> {
    const url = `${environment.apiHost}/v3/contracts/parts/forVisit`;
    const params = mapToHttpParams({
      areaId,
      visitId,
    });

    return this.http.get<AreaContractPart[]>(url, { params });
  }

  public addMonitor(monitor: AddMonitorDialogResponse): Observable<void> {
    const url = `${environment.apiHost}/locations/area/monitors`;

    const { mapCoordinates, ...rest } = monitor;
    const payload = {
      ...rest,
      coordinates: mapCoordinates,
    };

    return this.http.post<void>(url, payload);
  }

  public addAction(action: any): Observable<void> {
    const url = `${environment.apiHost}/actionPoints`;
    return this.http.post<void>(url, action);
  }

  public replaceMonitor(
    monitor: ReplaceMonitorDialogResponse
  ): Observable<{ id: number }> {
    const url = `${environment.apiHost}/mobile/replace-monitor`;
    return this.http.post<{ id: number }>(url, monitor);
  }

  public updateMonitorsPositions(
    monitorsPositions: MonitorsPositionChanged
  ): Observable<void> {
    const url = `${environment.apiHost}/locations/area/monitors/coordinates`;
    const body = monitorsPositions;

    return this.http.patch<void>(url, body);
  }
}

export type AreaContractPart = {
  contractPartId: number;
  label: string;
  moduleId: number;
};
